"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, UserAvatar } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsAvatar() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Avatar
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            An image element with a fallback for representing the user.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/avatar" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Avatars with image and fallback</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="flex items-center gap-4">
            <UserAvatar alternative="JD" />
            <UserAvatar alternative="JS" />
            <UserAvatar imgSrc="https://github.com/shadcn.png" imgAlt="User" />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">imgSrc</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Image source URL</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">imgAlt</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Image alt text</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">alternative</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Fallback text (e.g., initials)</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
